/**
 * Created by Ning Jiang on 6/12/2019.
 */

import {CountDownTimer} from "@nolimitcity/slot-game/bin/core/component/CountDownTimer";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";
import {PixiesVsPiratesInitialWinCountUp} from "../../winpresentation/initial/PixiesVsPiratesInitialWinCountUp";
import {FreespinOutroContainer} from "../FreespinOutroContainer";
import {PixiesVsPirates} from "../../PixiesVsPirates";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class PPPickNClickOutroView extends ScreenView {

    private _stillBg:PIXI.Sprite;
    private _blurBg:PIXI.Sprite;
    private _outroInfoContainer:FreespinOutroContainer;
    private _playSoundCallback:() => void;
    private _totalWinCountUp:PixiesVsPiratesInitialWinCountUp;

    constructor(config:IScreenViewConfig) {
        super(config, false);
        this._totalWinCountUp = new PixiesVsPiratesInitialWinCountUp(PixiesVsPiratesGameConfig.instance.OUTRO_COUNTUP_BITMAP_STYLE);
    }

    protected createBackground():PIXI.DisplayObject {
        const bg:PIXI.Container = new PIXI.Container;

        const still:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsIntroBG")[0]);
        still.alpha = 0;
        still.visible = false;
        still.anchor.set(0.5);
        bg.addChild(still);
        this._stillBg = still;

        const blur:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsIntroBGBlur")[0]);
        blur.alpha = 0;
        blur.visible = false;
        blur.anchor.set(0.5);
        bg.addChild(blur);
        this._blurBg = blur;

        return bg;
    }

    protected onResizeBackground(data:IResizeData):void {
        // resize together with onResizeGameGraphics
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._outroInfoContainer = new FreespinOutroContainer();
        this._outroInfoContainer.totalWinCountUp = this._totalWinCountUp;
        this._outroInfoContainer.alpha = 0;
        this._outroInfoContainer.visible = false;
        return this._outroInfoContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        const scale:number = Math.max(this._screenWidth / this._stillBg.texture.width, this._screenHeight / this._stillBg.texture.height);

        this._background.position.set(this._screenWidth / 2, this._screenHeight / 2);
        this._background.scale.set(scale, scale);

        this._outroInfoContainer.position.set(this._screenWidth / 2, this._screenHeight / 2);
        this._outroInfoContainer.updateElementsPosition(this._screenWidth, this._screenHeight, resizeData.orientation);

        if(resizeData.orientation === Orientation.PORTRAIT){
            this._outroInfoContainer.scale.set(scale, scale);
        }else{
            const defaultScale:number = Math.max(PixiesVsPiratesGameConfig.instance.GAME_WIDTH/ this._stillBg.texture.width, PixiesVsPiratesGameConfig.instance.GAME_HEIGHT / this._stillBg.texture.height);
            this._outroInfoContainer.scale.set(defaultScale);
        }
    }

    protected createButton():NineSliceButton {
        const button:NineSliceButton = super.createButton();
        button.visible = false;
        return button;
    }

    protected createAutoCloseTimer():CountDownTimer {
        const countDown:CountDownTimer = super.createAutoCloseTimer();
        countDown.visible = false;
        return countDown;
    }

    protected startPresentation(data?:PixiesVsPiratesParsedGameData, onShowComplete?:() => void):void {
        const tw:number = (data && data.accumulatedRoundWin)? data.accumulatedRoundWin : data!.totalWin;
        const timeline:TimelineLite = new TimelineLite(),
            // #272
            totalWinBelowStake: boolean = (PixiesVsPirates.api.gameClientConfiguration.belowStakeWinRestriction && (tw <= data!.playedBetValue));

        timeline.add([
            TweenLite.to(this._stillBg, 0.5, {alpha : 1, onStart : () => this._stillBg.visible = true}),
        ], 0); //  0-.5 sec
        timeline.add([
            TweenLite.to(this._blurBg, 0.5, {alpha : 1, onStart : () => this._blurBg.visible = true}),
            this._outroInfoContainer.show(data!.totalWin, data!.numberOfFreespinsPlayed!, data!.pixieFSCount, data!.pirateFSCount, false, data!.playerFSSelection, totalWinBelowStake),
            TweenLite.to(this._outroInfoContainer, 0.7, {
                alpha : 1,
                onStart : () => {
                    this._outroInfoContainer.visible = true;
                }
            })
        ], 0.5); // .5-1 sec
        timeline.add(() => this.playSound(), 0);
        timeline.add(() => {
            this._button.visible = true;
            // this._autoCloseTimer.visible = true;
            if(onShowComplete) {
                onShowComplete();
            }
        });
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.to(this._stillBg, 0.5, {alpha : 0, onComplete : () => this._stillBg.visible = false}),
            TweenLite.to(this._blurBg, 0.5, {alpha : 0, onComplete : () => this._blurBg.visible = false}),
            TweenLite.to(this._outroInfoContainer, 0.3, {
                alpha : 0,
                onComplete : () => {
                    this._outroInfoContainer.visible = false;
                    this._outroInfoContainer.close();
                }
            })
        ]);
        timeline.add(() => super.stopPresentation(closeCallback));
        timeline.play();
    }

    public getPlaySoundCallback(playSoundCallback:() => void):void {
        this._playSoundCallback = playSoundCallback;
    }

    private playSound():void {
        if(this._playSoundCallback) {
            this._playSoundCallback();
        }
    }
}